/* global AppSettings */
/**
 * Birthdate validation
 *
 * @author Andy Lemaire
 */

import createLogger from 'components/logger/Logger';
import EventTypes from 'components/EventTypes';

const Logger = createLogger('birthdateValidation');

export default class BirthdateValidation {
  constructor(form, element) {
    Logger.info('Initialized');
    this.form = form;
    this.container = this.form.querySelector('.js-birthdateSelect');

    if (this.container) {
      this.elements = [...this.container.querySelectorAll(element)];
    }

    this.bindEvents();
  }

  bindEvents() {
    const onChange = event => this.onChange(event);

    if (this.elements) {
      this.elements.forEach(element => element.addEventListener('change', onChange));
    }
  }

  calculateAge(dob) {
    const diffMs = Date.now() - dob.getTime();
    const ageDt = new Date(diffMs);
    return Math.abs(ageDt.getUTCFullYear() - 1970);
  }

  onChange(event) {
    let required = false;
    this.elements.forEach(element => {
      if (element.value) {
        required = true;
      }
    });

    if (!event.target.value.match(/^\d{1,}$/)) {
      event.target.value = '';

      return;
    }

    // make sure we find the correct name
    if (event.target.name.toLowerCase().includes('year')) {
      event.target.value = event.target.value.slice(0, 4);
    } else {
      event.target.value = event.target.value.slice(0, 2);
    }

    this.elements.forEach(element => (element.required = required));

    if (this.elements.every(element => element.value)) {
      this.triggerValidation();
    }
  }

  isValidDate(y, m, d, dob) {
    // detect Invalid Date
    if (dob instanceof Date && isNaN(dob)) {
      return false;
    }

    return (
      dob.getFullYear() === parseInt(y) &&
      dob.getMonth() === parseInt(m) &&
      dob.getDate() === parseInt(d)
    );
  }

  triggerValidation() {
    let y;
    let m;
    let d;

    this.elements.forEach(element => {
      const elementName = element.name.toLowerCase();

      if (!element.value) {
        return;
      }

      if (elementName.includes('year')) {
        y = element.value;
      }

      if (elementName.includes('month')) {
        m = element.value - 1;
      }

      if (elementName.includes('day')) {
        d = element.value;
      }
    });

    this.validate(y, m, d);
  }

  validate(y, m, d) {
    const dob = new Date(y, m, d);
    const isValidDate = this.isValidDate(y, m, d, dob);

    this.elements.forEach(element =>
      document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_HIDE, [this.form, element])
    );

    if (!isValidDate) {
      const errornonExistingDate = window.labels?.birthdateValidation?.nonExistingDate || '';
      this.elements.forEach(element =>
        document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_SHOW, [
          this.form,
          element,
          errornonExistingDate,
        ])
      );
      return;
    }

    const age = this.calculateAge(dob);
    const maxAge = AppSettings.maxConsumerAge;
    const minAge = AppSettings.minConsumerAge;
    const oldEnough = maxAge > age && age >= minAge;

    if (!oldEnough) {
      if (age >= maxAge) {
        const errorMaxAge = window.labels?.birthdateValidation?.maxAge || '';
        this.elements.forEach(element =>
          document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_SHOW, [this.form, element, errorMaxAge])
        );
      }

      if (age < minAge) {
        const errorMinAge = window.labels?.birthdateValidation?.minAge || '';
        this.elements.forEach(element =>
          document.jq.trigger(EventTypes.FORM_ELEMENT_ERROR_SHOW, [this.form, element, errorMinAge])
        );
      }
    }
  }
}
